import angular from 'angular';
import loanProductFinder from './loanProductFinder';
import tradePersonalReferencesSection from './tradePersonalReferencesSection';
import insuranceReferralsSection from './insuranceReferralsSection';
import fundingDetailsSection from './fundingDetailsSection';
import conflictInterestDeclarations from './conflictInterestDeclarations';

export default angular.module('loanAppSections.scenes', [
  loanProductFinder,
  tradePersonalReferencesSection,
  insuranceReferralsSection,
  fundingDetailsSection,
  conflictInterestDeclarations,
]).name;
